import { forwardRef, useCallback } from 'react'
import Typography from '@mui/material/Typography'
import { ReactComponent as CheckCircleIcon } from '../../icons/successIcon.svg';
import { ReactComponent as RemoveCircleIcon } from '../../icons/deleteIcon.svg';
import { ReactComponent as WarningIcon } from '../../icons/warningIcon.svg';
import { ReactComponent as InfoIcon } from '../../icons/infoIcon.svg';
import { ReactComponent as ErrorIcon } from '../../icons/deleteIcon.svg';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as CloseIcon } from '../../icons/clsbutton.svg';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { SnackbarContent, } from 'notistack'
import { useMediaQuery } from '@mui/material';
import { store } from '../../context/store';
let snackBarRef = null;
let closeSnacBarRef = null;

export function setSnackBarRef(value) {
    snackBarRef = value;
}

export function setCloseSnackBarRef(value) {
    closeSnacBarRef = value;
}




const CustomSnackBar = forwardRef((props, ref) => {
    let notficationColor = props.variant === 'success' ? '#70B173' : '#E65B5C'
    const successIcon = <CheckCircleIcon sx={{ color: notficationColor }} />
    const infoIcon = <InfoIcon sx={{ color: '#3296FB' }} />
    const warningIcon = <WarningIcon sx={{ color: '#E0A751', fontSize: '22px' }} />
    const deleteIcon = <RemoveCircleIcon sx={{ color: notficationColor }} />
    const errorIcon = <ErrorIcon sx={{ color: notficationColor }} />
    let icons = { 'success': successIcon, 'info': infoIcon, 'warn': warningIcon, 'delete': deleteIcon, 'error': errorIcon }
    const isMobileView = useMediaQuery('(max-width:650px)');

    const handleDismiss = useCallback(() => {
        closeSnacBarRef(props.id);
    }, [props.id]);


    return (
        <SnackbarContent className='oz-tb-snackbar' ref={ref} role="alert">
            <div style={{
                border: `1px solid ${notficationColor}`
            }} className={isMobileView ? "oz-tb-snackbar-mobile" : "oz-tb-snackbar-desktop"}>
                {icons[props.variant]}
                <Typography fontSize={'14px'} fontWeight={400} lineHeight={'16px'} color='#212121' margin={'10px'} flexGrow={1} >
                    {props.message}
                </Typography>
                {!(props.actionFunction === undefined) &&
                    <>
                        <Divider orientation='vertical' color='#536580' sx={{ height: '70%', marginRight: '8px' }} />
                        <Button
                            variant='text'
                            size='small'
                            sx={{
                                fontWeight: '600',
                                color: '#536580',
                                fontSize: 14,
                                minWidth: '45px'
                            }} onClick={props.actionFunction}>
                            undo
                        </Button>
                    </>
                }
                <IconButton
                    aria-label="close"
                    onClick={handleDismiss}
                    sx={{
                        color: '#99A0A8',
                        padding: 0
                    }}
                >
                    <CloseIcon sx={{ fontSize: '20px' }} />
                </IconButton>
            </div>
        </SnackbarContent>
    )
})


export function showSuccessNotification(message, actionFunction) {
    if (snackBarRef != null) {
        snackBarRef(message, {
            variant: 'success', content: (key, message) => (
                <CustomSnackBar id={key} message={message} variant={'success'} actionFunction={actionFunction} />
            ),
        })
    }
}

export function showWarningNotification(message, actionFunction) {
    if (snackBarRef != null) {
        snackBarRef(message, {
            variant: 'warn', content: (key, message) => (
                <CustomSnackBar id={key} message={message} variant={'warn'} actionFunction={actionFunction} />
            ),
        })
    }
}

export function showErrorNotification(message, actionFunction) {
    if (snackBarRef != null) {
        snackBarRef(message, {
            variant: 'error', content: (key, message) => (
                <CustomSnackBar id={key} message={message} variant={'error'} actionFunction={actionFunction} />
            ),
        })
    }
}

export function showInfoNotification(message, actionFunction) {
    if (snackBarRef != null) {
        snackBarRef(message, {
            variant: 'info', content: (key, message) => (
                <CustomSnackBar id={key} message={message} variant={'info'} actionFunction={actionFunction} />
            ),
        })
    }
}

export function showClickableSnackbar(message, onClickAction) {
    if (snackBarRef != null) {
        snackBarRef(message, {
            variant: 'info',
            content: (key, message) => (
                <ClickableSnackbar
                    id={key}
                    message={message}
                    variant={'info'}
                    onClickAction={onClickAction}
                    closeSnackbar={() => closeSnacBarRef(key)} // ✅ pass close function
                />
            ),
        });
    }
}

export const ClickableSnackbar = forwardRef((props, ref) => {
    const {onClickAction, closeSnackbar } = props;
    let notficationColor = props.variant === 'success' ? '#70B173' : '#E65B5C'
    const infoIcon = <InfoIcon sx={{ color: '#3296FB' }} />
    let icons = {  'info': infoIcon}
    const isMobileView = useMediaQuery('(max-width:650px)');

    const handleDismiss = useCallback((e) => {
        e.stopPropagation(); // ✅ prevent triggering onClickAction
        closeSnackbar();     // ✅ close the snackbar
    }, [closeSnackbar]);

    const handleClick = useCallback(() => {
        onClickAction?.(); // ✅ call action function
        closeSnackbar();   // ✅ also close after click (optional, remove if not needed)
    }, [onClickAction, closeSnackbar]);
  const isChatQueueOpen = store.getState().digital.isChatQueueOpen;

    return (
        <SnackbarContent ref={ref} role="alert">
            <div
                onClick={handleClick} // ✅ click anywhere = action + close
              style={{
                border: `1px solid ${notficationColor}`,cursor:'pointer'
            }} className={isMobileView ? "oz-tb-snackbar-mobile" : "oz-tb-snackbar-desktop"}>
                {icons[props.variant]}
                <Typography fontSize={'14px'} fontWeight={400} lineHeight={'16px'} color='#212121' margin={'10px'} flexGrow={1} >
                    {props.message}
                    {!isChatQueueOpen && <span style={{
                        color: '#0078d4',       // Professional Outlook/Azure Blue
                        fontWeight: '600',      // Slightly bolder to stand out
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        marginLeft: '4px',
                        display: 'inline-block',
                        transition: 'color 0.2s'
                    }}>
                        {/* Replace with your i18n variable here */}
                        click here to open
                    </span>}
                </Typography>

                <IconButton
                    size="small"
                    onClick={handleDismiss} // ✅ X button = only close
                >
                    <CloseIcon style={{ fontSize: '18px' }} />
                </IconButton>
            </div>
        </SnackbarContent>
    );
});